import { range } from 'es-toolkit/compat';
export default range;
